import { IonButtons, IonContent, IonHeader, IonItem, IonLabel, IonMenuButton, IonPage, IonTitle, IonToolbar 
,IonList
,IonThumbnail
,IonImg
} from '@ionic/react';
//import { useParams } from 'react-router';
import './Wp.css';
import OpenMenuButton from "../../../components/OpenMenuButton";
import React, { useState, useEffect } from 'react';

const Wp: React.FC = () => {

 const name:string = "Work Permit";
 const [actionId, setActionId] = useState("");
 const now = new Date();
 const dummy = now.getDate()+ '_' + now.getSeconds()+ '_' + now.getMinutes() + '_' + now.getHours();
 type Item = {
  src: string;
  text: string;
  id: string;
};
const items: Item[] = [
  { src: 'assets/img/contact-icon.png', text: 'ID Check', id: "0" }
 ,{ src: 'assets/img/check-icon.png', text: 'Site Inspection', id: "1" }
 ,{ src: 'assets/img/document.png', text: 'Work Permit', id: "2" }
];


useEffect(() => {
    
}, [actionId])
const rountTo = function(id:any) {
   if(id=="0"){
     return "wpForm/0";
   }else if(id=="1"){
    return "wpIns/0";
   }else if(id=="2"){
    return "wpWork/0";
   }
}

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton />
            <OpenMenuButton />
          </IonButtons>
          <IonTitle>{name}</IonTitle>
        </IonToolbar>
      </IonHeader>

      <IonContent>
        <IonHeader collapse="condense">
          <IonToolbar>
            <IonTitle>{name}</IonTitle>
          </IonToolbar>
        </IonHeader>
     
    <IonList>
      {items.map((image, i) => (
        <IonItem key={i}  routerLink={"/page/home/wp/"+rountTo(image.id)+"/"+dummy} onClick={(e) => {}} >
          <IonThumbnail slot="start">
            <IonImg src={image.src} />
          </IonThumbnail>
          <IonLabel>{image.text}</IonLabel>
        </IonItem>
       
      ))}
    </IonList>

      </IonContent>
   
    </IonPage>
  );
};

export default Wp;
